import React, { useEffect, useRef, useState } from 'react';
import { Check } from 'lucide-react';
import { TIMES, TIME_IDS } from './scene/DayNight';

// Round button showing the time of day; opens a menu with morning, afternoon, evening and night.
// The gallery starts at the visitor's own local time; picking another one lasts for the visit.
const TimeControl = ({ value, startedFrom, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  const night = value === 'night';
  const item = 'w-full flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-amber-50 text-left';
  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        className={`h-10 w-10 rounded-full shadow-md flex items-center justify-center text-lg ${night ? 'bg-indigo-900 hover:bg-indigo-800' : 'bg-white/90 hover:bg-amber-100'}`}
        title={`Time of day: ${TIMES[value].label} (N for the next one)`}
        aria-label={`Time of day: ${TIMES[value].label}`}
      >
        <span>{TIMES[value].icon}</span>
      </button>
      {open && (
        <div className="absolute right-12 top-0 w-52 bg-white/95 backdrop-blur-sm rounded-lg shadow-xl border p-1 z-50">
          <div className="px-3 pt-2 pb-1 text-xs font-semibold uppercase tracking-wider text-gray-500">Time of day</div>
          {TIME_IDS.map((id) => (
            <button key={id} className={item} onClick={() => { onChange(id); setOpen(false); }}>
              <span className="w-4 text-center">{TIMES[id].icon}</span>
              <span className="flex-1">
                {TIMES[id].label}
                {id === startedFrom && <span className="block text-[11px] text-gray-500">Your local time</span>}
              </span>
              {value === id && <Check size={16} className="text-amber-700" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TimeControl;
